module.exports = "<div class=\"form-group\">\n    <label>Tag</label>\n    <input ng-model=\"element.data.tag\" />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./sgcontenteditor/customElements/properties/testimonialcirclefeature.html
// module id = 426
// module chunks = 0